import DashboardV2 from "./home/v2/dashboardV2";


export default function DashboardRouter() {
  return <DashboardV2 />;
}
